import { render, staticRenderFns } from "./support-auth.vue?vue&type=template&id=103f9dc6&"
import script from "./support-auth.vue?vue&type=script&lang=js&"
export * from "./support-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports